"use client";

import { c as _c } from "react/compiler-runtime";
import { ApolloProvider, type NormalizedCacheObject } from "@apollo/client";
import React, { type ReactNode, useMemo } from "react";
import { createApolloClient } from "#/graphql/createApolloClient";
type ApolloHydrationProviderProps = {
  initialCache: NormalizedCacheObject | null;
  children: ReactNode;
};

/**
 * Route-scoped Apollo client with optional server-extracted cache (daily, profile).
 */
export const ApolloHydrationProvider: React.FC<ApolloHydrationProviderProps> = t0 => {
  const $ = _c(5);
  const {
    initialCache,
    children
  } = t0;
  const t1 = initialCache ?? undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = createApolloClient({
      initialState: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const client = t2;
  let t3;
  if ($[2] !== children || $[3] !== client) {
    t3 = <ApolloProvider client={client}>{children}</ApolloProvider>;
    $[2] = children;
    $[3] = client;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};